export default () => ({
  amount: 50,
  isCustom: false,
  firstName: null,
  lastName: null,
  email: null,
  termsAccepted: false,
  purpose: null,
  source: null,
  init () {
    this.source = window.location.href;
    this.purpose = this.setPurpose ();
    console.log ( this.purpose );
    console.log ( this.source );
  },
  handleClick ( amount, isCustom ) {
    this.amount = amount;
    this.isCustom = isCustom;

    if ( isCustom ) {
      this.$refs.custom.focus ();
      if ( this.$refs.custom.value.length ) {
        this.amount = this.$refs.custom.value;
      }
    }
  },
  isFormComplete () {
    if ( (this.amount !== null && this.amount > 0) &&
      (this.firstName !== null && this.firstName.length > 2) &&
      (this.lastName !== null && this.lastName.length > 2) &&
      (this.email !== null && this.email.length > 2) &&
      this.termsAccepted !== false ) {
      return true;
    } else {
      return false;
    }
  },
  submit () {
    // If form is not completed don't submit
    if ( !this.isFormComplete () ) return;

    this.postRequest ();
  },
  postRequest () {
    $.ajax ( {
      url: themosis.ajaxurl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'donate',
        security: themosis.nonce,
        product_id: 45710,
        quantity: 1,
        amount: this.amount,
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        purpose: this.purpose,
        source: this.source,
      },
      complete: () => {
        console.log ( 'complete' );
      },
      success ( response ) {
        window.location.href = response;
      },
    } );
  },
  setPurpose () {
    if ( this.source.includes ( 'marzyciele' ) ) {
      const part = this.source.substring ( this.source.lastIndexOf ( '/' ) + 1 ); // Get the part after the last '/'
      const [ id, name ] = part.split ( '-' ); // Split by '-'

      return `Marzyciel - ID: ${id}, Imię: ${name}`;
    }

    return 'Fundacja';
  },
})
